import {Component, OnInit} from '@angular/core';
import {EventResponse} from "../../../shared/model/response/event/event-response.model";
import {PaginatorState} from "primeng/paginator";
import {EventService} from "../../../service/api/event.service";
import {EventFilterModel} from "../../../shared/model/request/event-filter.model";
import {PageInfo} from "../../../shared/model/response/page-info.model";
import {DatePipe} from "@angular/common";
import {AuthenticationService} from "../../../service/authentication-service";
import {AuthtokenResponse} from "../../../shared/model/response/auth/authtoken-response.model";

@Component({
    selector: 'app-user-event',
    templateUrl: './user-event.component.html',
    styleUrls: ['./user-event.component.css'],
    standalone: false
})
export class UserEventComponent implements OnInit {

  events: EventResponse[];
  pagination: PageInfo

  user: AuthtokenResponse

  eventFilters: EventFilterModel = {}
  hasEvents: boolean = true

  constructor(
    private datePipe: DatePipe,
    private eventService: EventService,
    private authenticationService: AuthenticationService,
  ) {
  }

  ngOnInit() {
    this.user = this.authenticationService._user.getValue()
    this.fetchEvents(this.eventFilters)
  }

  onFilterSubmit($event: EventFilterModel) {
    this.eventFilters = $event
    this.fetchEvents(this.eventFilters)
  }


  fetchEvents(filters: EventFilterModel, page?: number) {
    filters.userId = this.user.id
    filters.admin = true
    this.eventService.getEvents(page, filters)
      .subscribe({
          next: (value) => {
            this.events = value?.data
            this.pagination = value.pageInfo
            this.hasEvents = this.events.length > 0
          },
          error: () => {
            if (page == 0) {
              this.hasEvents = false;
              this.events = null;
            }
          }
        }
      )
  }

  onPageChange($event: PaginatorState) {
    this.fetchEvents(this.eventFilters, $event.page)
  }
}
